import React from 'react';
import {
  adicionarContrato,
  adicionarContratoAntigo,
  obterContratoPeloNumero,
  obterContratosInserir,
  obterContratosCadastrados,
  obterContratosConfigurar,
  editarContrato,
  transferirContrato,
} from '../../actions/ContratoActions';
import { adicionarTurma } from '../../actions/TurmaActions';
import { obterItensPeloContrato } from '../../actions/ItemActions';
import { connect } from 'react-redux';
import { cadastrarAcao } from '../../actions/AcaoActions';
import { obterUsuariosPeloContrato } from '../../actions/UsuarioContratoActions';
import {
  obterUsuariosAdministracao,
  editarUsuario,
} from '../../actions/UsuarioActions';
import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import EmailServices from '../../services/email';
import MapaServices from '../../services/mapa';
import './styles.css';

const animatedComponents = makeAnimated();

class ContratosGerenciamento extends React.Component {
  state = {
    contrato: {
      codigoTemplate: '',
      numero: '',
      prazoFinalizacao: undefined,
      emailComissao: '',
      nomeComissao: '',
      dono: '',
      tipoContrato: '',
      telefone: '',
      dataFormatura: '',
      dataChegada: '',
      dataEntrega: '',
      idClienteMetrics: '',
      numOrcamento: '',
      contratante: '',
      statusCronograma: '',
      contatos: [],
      itens: [],
      gestor: '',
      emailGestor: '',
      idGestorMetrics: '',
      instituicao: '',
      idInstituicao: '',
      termoAprovado: 'false',
      sigla: '',
      curso: '',
      idCurso: '',
      cidade: '',
      idCidade: '',
      estado: '',
      idEstado: '',
      representante: '',
      idRepresentante: '',
      parceiro: '',
      idParceiro: '',
      pagamentoIndividual: '',
      selecionado: [],
      codigoAlbumConvite: '',
      contratoVitrine: '',
    },
    oldContrato: {
      numero: '',
      emailComissao: '',
      emailDesigner: '',
      prazoFinalizacao: '',
      dono: '',
      status: 'aguardando',
    },
    cursos: [],
    cursosSelecionados: [],
    classInputs: {
      numero: '',
      gestor: '',
      emailComissao: '',
      telefone: '',
      numOrcamento: '',
      tipoContrato: '',
      instituicao: '',
      sigla: '',
      curso: '',
      cidade: '',
      estado: '',
      representante: '',
      parceiro: '',
      dataFormatura: '',
      dataChegada: '',
      dataEntrega: '',
      prazoFinalizacao: '',
      statusCronograma: '',
      cursosSelecionados: { display: 'none' },
    },
    modalCorrecao: {
      show: false,
      emailEnviado: false,
      carregando: false,
      titulo: '',
      tipo: '',
      inputCorrecao: '',
      dadosAlteracao: {
        nome: '',
        email: '',
        telefone: '',
        outroTelefone: '',
      },
    },
    designers: [],
    designerSelecionado: {},
    oldDono: {},
    datatables: ['datatableMetricsCadastrar', 'datatableMetricsInserir'],
    showModalGestores: false,
    showModalItensKit: false,
    showModalNovo: false,
    showModalContratoAntigo: false,
    showModalContato: false,
    carregando: false,
    habilitarInputsOldForm: false,
    kitSelecionado: null,
    qtdKitSelecionado: '',
    iniciar: true,
    output: 'none',
    clientesMetricsNConfigurados: [],
    diagramadores: [],
    kits: [],
    precoTotalOrcamento: '',
    abrindoContrato: false,
    contratosNovos: [],
    contratoDoBanco: {},
    cliente: null,
    emailAntigo: '',
  };

  async componentWillMount() {
    await Promise.all([
      this.handleMountTableCadastrar(),
      this.handleMountTableInserir(),
    ]).then(() => {
      let designers = [];
      this.props.usuario.todos.forEach((usuario) => {
        if (usuario.idResponsavel) {
          designers.push({
            label: usuario.nome,
            value: usuario.id,
            idGestorMetrics: usuario.idResponsavel,
            emailGestor: usuario.email,
          });
        }
      });
      designers = designers.sort((a, b) => {
        return a.label > b.label ? 1 : -1;
      });
      this.setState(
        { designers, diagramadores: this.props.usuario.todos },
        () => {
          setTimeout(() => {
            this.setState({ iniciar: false });
          }, 1000);
        }
      );
    });
  }

  async componentDidMount() {
    window.iniciarVariosDataTables(this.state.datatables);
  }

  handleChangeGestor(designerSelecionado) {
    let contrato = this.state.contrato;
    contrato.dono = designerSelecionado.value;
    contrato.gestor = designerSelecionado.label;
    contrato.emailGestor = designerSelecionado.emailGestor;
    contrato.idGestorMetrics = designerSelecionado.idGestorMetrics;
    this.setState({ contrato, designerSelecionado });
  }

  enviarEmail = (e) => {
    e.preventDefault();
    toast.info('A solicitação está sendo enviada. Aguarde!');
    let email = new EmailServices();
    if (this.state.modalCorrecao.tipo === 'adicao') {
      email.enviar('adicionarContato', {
        usuario: { nome: 'Orçamentista' },
        numContrato: this.state.contrato.numero,
        novosDados: this.state.modalCorrecao.dadosAlteracao,
        solicitadoPor: JSON.parse(
          localStorage.getItem('usuarioLogadoAdministracao')
        ).nome,
      });
      this.resetarModalCorrecao();
    } else {
      email.enviar('alterarDadosContato', {
        usuario: { nome: 'Orçamentista' },
        numContrato: this.state.contrato.numero,
        dadosAntigos: this.state.modalCorrecao.dadosAlteracao,
        novosDados: this.state.modalCorrecao.inputCorrecao,
        solicitadoPor: JSON.parse(
          localStorage.getItem('usuarioLogadoAdministracao')
        ).nome,
      });
      this.resetarModalCorrecao();
    }
  };

  resetarModalCorrecao = () => {
    this.setState({
      modalCorrecao: {
        show: false,
        emailEnviado: true,
        carregando: false,
        titulo: '',
        tipo: '',
        inputCorrecao: '',
        dadosAlteracao: {
          nome: '',
          email: '',
          telefone: '',
        },
      },
    });
  };

  fixDataContrato(contrato) {
    if (contrato.dataChegada.includes('T')) {
      let data = new Date(contrato.dataChegada).toLocaleDateString('pt-BR', {
        timeZone: 'UTC',
      });
      data = data.split('T')[0].split('/').reverse().join('-');
      contrato.dataChegada = data;
    }
    if (contrato.dataFormatura.includes('T')) {
      let data = new Date(contrato.dataFormatura).toLocaleDateString('pt-BR', {
        timeZone: 'UTC',
      });
      data = data.split('T')[0].split('/').reverse().join('-');
      contrato.dataFormatura = data;
    }
    if (contrato.dataEntrega.includes('T')) {
      let data = new Date(contrato.dataEntrega).toLocaleDateString('pt-BR', {
        timeZone: 'UTC',
      });
      data = data.split('T')[0].split('/').reverse().join('-');
      contrato.dataEntrega = data;
    }
    if (
      contrato.prazoFinalizacao === undefined ||
      contrato.prazoFinalizacao === null ||
      contrato.prazoFinalizacao === 'Invalid Date' ||
      contrato.prazoFinalizacao.includes('1970')
    ) {
      contrato.prazoFinalizacao = undefined;
    } else {
      let data = new Date(contrato.prazoFinalizacao).toLocaleDateString(
        'pt-BR',
        { timeZone: 'UTC' }
      );
      data = data.split('T')[0].split('/').reverse().join('-');
      contrato.prazoFinalizacao = data;
    }
    return contrato;
  }

  async handleMountTableCadastrar() {
    if (
      this.state.contratoDoBanco.length === undefined ||
      this.state.contratoDoBanco.length === 0
    ) {
      await this.props.obterUsuariosAdministracao();
      if (
        this.props.usuario.autenticado.tipo === 'administrador' ||
        this.props.usuario.autenticado.tipo === 'orc'
      ) {
        await Promise.all([this.props.obterContratosCadastrados(-1)]).then(
          () => {
            this.setState({
              contratoDoBanco: this.props.contratosNovos,
              contratosNovos: [],
            });
          }
        );
      } else {
        await Promise.all([
          this.props.obterContratosConfigurar(
            this.props.usuario.autenticado.id
          ),
        ]).then(() => {
          this.setState({
            contratoDoBanco: this.props.contratosConfigurar,
            contratosNovos: [],
          });
        });
      }
    }
    let mapaservice = new MapaServices(),
      novos = [],
      jaMostrouUmaNotificacao = false;
    if (this.state.contratoDoBanco.length > 0) {
      this.state.contratoDoBanco.map(async (item) => {
        if (item.numOrcamento !== null) {
          await mapaservice
            .getTabela(item.numOrcamento)
            .then(async (orcamento) => {
              item.curso = orcamento.curso !== undefined ? orcamento.curso : '';
              item.representante = orcamento.Nome;
              item.parceiro =
                orcamento.NomeAgencia === null || orcamento.NomeAgencia === ''
                  ? ''
                  : orcamento.NomeAgencia;
              item.instituicao = orcamento.Instituicao;
              item.sigla = orcamento.SiglaInst;
              item.cidade = orcamento.Cidade;
              item.estado = orcamento.SiglaEstado;
            })
            .catch(() => {
              if (!jaMostrouUmaNotificacao) {
                jaMostrouUmaNotificacao = true;
                toast.warn(
                  'Pode ser que alguns contratos não tenham todas as informações!'
                );
              }
            });
        } else if (item !== null) {
          item.curso = '';
          item.representante = '';
          item.parceiro = '';
          item.instituicao = '';
          item.sigla = '';
          item.cidade = '';
          item.estado = '';
        }
        novos.push(item);
        this.setState({ contratosNovos: novos });
      });
    }
  }

  async handleMountTableInserir() {
    await this.props.obterContratosInserir();
  }

  async componentWillUpdate() {
    window.destruirVariosDataTables(this.state.datatables);
    if (this.state.atualizarTabelas === true) {
      this.setState({ atualizarTabelas: false, iniciar: true });
      await Promise.all([
        this.handleMountTableCadastrar(),
        this.handleMountTableInserir(),
      ]).then(() => {
        setTimeout(() => {
          this.setState({ iniciar: false });
        }, 2000);
      });
    }
  }

  async componentDidUpdate() {
    window.desenharVariosDataTables(this.state.datatables);
  }

  alterarForm = (e) => {
    let contrato = this.state.contrato,
      campo = e.target.name,
      valor = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    contrato[campo] = valor;
    this.limparClassInputs();
    this.setState({ contrato });
  };

  alterarFormAntigo(event) {
    const campo = event.target.name;
    const oldContrato = this.state.oldContrato;
    oldContrato[campo] = event.target.value;
    return this.setState({ oldContrato });
  }

  cadastrarContratoAntigo(event) {
    event.preventDefault();
    let contrato = this.state.oldContrato;
    contrato.dono = this.props.usuario.autenticado.id;
    contrato.status = 'aguardando';
    contrato.dataInicio = new Date();
    this.props.adicionarContratoAntigo(contrato).then((response) => {
      this.setState({
        oldContrato: {
          numero: '',
          emailComissao: '',
          emailDesigner: '',
          prazoFinalizacao: '',
          dono: '',
        },
        showModalContratoAntigo: false,
      });
    });
  }

  encontrarDiagramador(id) {
    let gestorPesquisado = { nome: null, codMetrics: null };
    if (this.state.diagramadores !== undefined) {
      this.state.diagramadores.forEach((item) => {
        if (id === item.id) {
          gestorPesquisado.nome = item.nome;
          gestorPesquisado.email = item.email;
          gestorPesquisado.codMetrics = item.idResponsavel;
        }
      });
    }
    return gestorPesquisado;
  }

  async setarInformacoesModalContrato(contrato, funcao) {
    let mapaservice = new MapaServices(),
      novoContrato = Object.assign({}, this.state.contrato),
      gestorPesquisado =
        contrato.dono !== undefined
          ? await this.encontrarDiagramador(contrato.dono)
          : '';
    mapaservice.getTabela(contrato.numOrcamento).then(async (data) => {
      novoContrato.id = contrato.id !== undefined ? contrato.id : '';
      novoContrato.idGestorMetrics =
        gestorPesquisado !== '' ? gestorPesquisado.codMetrics : '';
      novoContrato.usuario =
        contrato.usuario !== undefined ? contrato.usuario : '';
      novoContrato.contratante =
        contrato.contratante !== undefined
          ? contrato.contratante
          : contrato.Nome;
      novoContrato.idClienteMetrics = contrato.CodCliente;
      novoContrato.numero =
        contrato.numero !== undefined ? contrato.numero : '';
      novoContrato.gestor =
        gestorPesquisado !== '' ? gestorPesquisado.nome : '';
      novoContrato.dono = contrato.dono !== undefined ? contrato.dono : '';
      novoContrato.emailGestor = gestorPesquisado.email;
      novoContrato.emailComissao =
        contrato.emailComissao !== undefined
          ? contrato.emailComissao
          : contrato.email;
      novoContrato.nomeComissao =
        contrato.usuario !== undefined ? contrato.usuario.nome : contrato.nome;
      novoContrato.telefone =
        contrato.telefone !== undefined ? contrato.telefone : contrato.Telefone;
      novoContrato.numOrcamento =
        contrato.numOrcamento !== undefined ? contrato.numOrcamento : '';
      novoContrato.tipoContrato =
        contrato.tipoContrato !== undefined
          ? contrato.tipoContrato
          : contrato.TipoContrato;
      novoContrato.temPersonalizada = true;
      novoContrato.instituicao = data.Instituicao;
      novoContrato.idInstituicao = data.CodInst;
      novoContrato.sigla = data.SiglaInst;
      novoContrato.contatos = data.contatos;
      novoContrato.curso = data.curso;
      novoContrato.idCurso = data.codcurso;
      novoContrato.cidade = data.Cidade;
      novoContrato.pagamentoIndividual = contrato.pagamentoIndividual;
      novoContrato.contratoVitrine =
        contrato.contratoVitrine === 1 ? true : false;
      novoContrato.conviteOnline = contrato.conviteOnline === 1 ? true : false;
      novoContrato.idCidade = data.CodCid;
      novoContrato.estado = data.SiglaEstado;
      novoContrato.idEstado = data.codEstado;
      novoContrato.status =
        contrato.status !== undefined ? contrato.status : 'cadastrar';
      novoContrato.itens = contrato.itens;
      novoContrato.representante = data.Nome;
      novoContrato.idRepresentante = data.codVendedor;
      novoContrato.parceiro =
        data.codAgencia === 0 ? 'Não possui' : data.NomeAgencia;
      novoContrato.idClienteMapa = contrato.idClienteMapa;
      novoContrato.idParceiro = data.codAgencia;
      novoContrato.dataFormatura = contrato.dataFormatura
        ? new Date(contrato.dataFormatura)
            .toLocaleDateString('pt-BR', { timeZone: 'UTC' })
            .split('/')
            .reverse()
            .join('-')
        : '';
      novoContrato.dataChegada = contrato.dataChegada
        ? new Date(contrato.dataChegada)
            .toLocaleDateString('pt-BR', { timeZone: 'UTC' })
            .split('/')
            .reverse()
            .join('-')
        : '';
      novoContrato.dataEntrega = contrato.dataEntrega
        ? new Date(contrato.dataEntrega)
            .toLocaleDateString('pt-BR', { timeZone: 'UTC' })
            .split('/')
            .reverse()
            .join('-')
        : '';
      this.setState({
        contrato: novoContrato,
        showModalNovo: funcao,
        precoTotalOrcamento:
          data.CustTotal === undefined
            ? 'R$ 0,00'
            : data.CustTotal.toFixed(2).toLocaleString('pt-BR'),
        emailAntigo: contrato.emailComissao,
        oldDono: contrato.dono,
      });
    });
  }

  async abrirModalContrato(contrato) {
    this.setState({ abrindoContrato: true });
    let mapaservice = new MapaServices(),
      precoTotalOrcamento = 0;
    // Pegar contatos do MAPA
    if (!contrato.contatos && contrato.numOrcamento) {
      await mapaservice
        .getContatosByOrcamento(contrato.numOrcamento)
        .then((response) => {
          contrato.contatos = response;
        });
    }
    // Carregar itens do contrato
    await this.props.obterItensPeloContrato(contrato.id);
    contrato.itens = this.props.itensCadastrados;
    contrato.itens.forEach((item) => {
      precoTotalOrcamento += item.preco * item.quantidade;
    });
    precoTotalOrcamento = precoTotalOrcamento
      .toFixed(2)
      .toLocaleString('pt-BR');
    // Carregar as informações do designer
    let gestorPesquisado = await this.encontrarDiagramador(contrato.dono);
    contrato.gestor = gestorPesquisado.nome;
    contrato.emailGestor = gestorPesquisado.email;
    contrato.idGestorMetrics = gestorPesquisado.codMetrics;
    // Ajustar as datas para o formato do input
    contrato = this.fixDataContrato(contrato);
    // Carregar os cursos cadastrados
    let cursos = [];
    if (contrato.curso === 'VARIOS CURSOS' && this.state.cursos.length === 0) {
      await mapaservice.consultarCursos().then((response) => {
        response.forEach((curso) => {
          cursos.push({ value: curso.nomecurso, label: curso.nomecurso });
        });
      });
    }
    this.setState({
      cursos,
      contrato,
      showModalNovo:
        this.props.usuario.autenticado.tipo === 'comum' ? 'des' : 'ate',
      emailAntigo: contrato.emailComissao,
      precoTotalOrcamento,
      abrindoContrato: false,
    });
  }

  limparClassInputs() {
    let inputs = Object.keys(this.state.classInputs);
    let classInputs = this.state.classInputs;
    inputs.forEach((input) => {
      classInputs[input] = '';
    });
    classInputs['cursosSelecionados'] = { display: 'none' };
    this.setState({ classInputs });
  }

  mudarTipoItem(item) {
    let itens = this.state.contrato.itens;
    for (let i = 0; i < itens.length; i++) {
      if (item.produto.id === itens[i].produto.id) {
        if (itens[i].tipo) {
          if (itens[i].tipo === 'P') itens[i].tipo = 'F';
          else itens[i].tipo = 'P';
        } else {
          itens[i].tipo = 'P';
        }
        break;
      }
    }
    let contrato = this.state.contrato;
    contrato.itens = itens;
    this.setState({ contrato });
  }

  async cadastrarContrato() {
    let contrato = this.state.contrato;
    this.limparClassInputs();
    if (!this.verificarInputs('cadastrar')) {
      contrato.status = 'cadastrar';
      contrato.prazoFinalizacao = null;
      contrato.dataInicio = new Date();
      contrato.acao = 'cad';
      this.props.editarUsuario(contrato.usuario, contrato.usuario.id);
      let dono = { dono: contrato.dono };
      delete contrato.usuario;
      delete contrato.dono;
      await this.props.editarContrato(contrato.id, contrato).then(async () => {
        if (this.state.oldDono !== dono) {
          this.props.transferirContrato(dono, contrato.id);
        }
        this.setState({
          showModalNovo: false,
          atualizarTabelas: true,
          contratoDoBanco: {},
          iniciar: false,
          designerSelecionado: {},
        });
        await Promise.all([
          this.handleMountTableCadastrar(),
          this.handleMountTableInserir(),
        ]).then(() => {
          setTimeout(() => {
            this.setState({ iniciar: false });
          }, 2000);
        });
      });
    }
  }

  async configurarContrato(funcao) {
    let contrato = this.state.contrato,
      email = new EmailServices();
    this.limparClassInputs();
    contrato.usuario.email = contrato.emailComissao;
    contrato.usuario.login = contrato.emailComissao;
    if (funcao === 'salvar') {
      contrato.status = 'cadastrar';
    } else {
      contrato.status = 'configurar';
      if (contrato.curso === 'VARIOS CURSOS') {
        this.state.cursosSelecionados.forEach((curso) => {
          this.props.adicionarTurma({
            contrato: contrato.id,
            curso: curso.value,
          });
        });
      } else {
        this.props.adicionarTurma({
          contrato: contrato.id,
          curso: contrato.curso,
        });
      }
      this.props.editarUsuario(contrato.usuario, contrato.usuario.id);
      email.enviar('comissaoDesigner', {
        numero: contrato.numero,
        usuario: { nome: 'Vinculo de contrato' },
        designer: { email: contrato.emailGestor },
      });
    }
    if (!this.verificarInputs('configurar')) {
      this.props.editarUsuario(contrato.usuario, contrato.usuario.id);
      email.enviar(
        'comissao',
        {
          login: {
            email: contrato.usuario.login,
            senha: contrato.usuario.senha,
            nome: contrato.usuario.login,
          },
          usuario: {
            nome: contrato.usuario.nome,
            email: contrato.usuario.email,
          },
        },
        false
      );
      delete contrato.usuario;
      delete contrato.dono;
      contrato.prazoFinalizacao = '1970-01-01';
      await this.props.editarContrato(contrato.id, contrato).catch(() => {
        toast.error('Erro ao atualizar o contrato');
      });
      this.setState({ showModalNovo: false, contratoDoBanco: [] });
      await this.handleMountTableCadastrar();
    }
  }

  verificarInputs(status = null) {
    let inputs = [],
      existemCamposNaoPreenchidos = false,
      classInputs = this.state.classInputs;
    if (this.state.contrato.dono && this.state.contrato.dono !== 1288) {
      if (status === 'cadastrar') {
        inputs = [
          'numero',
          'gestor',
          'emailComissao',
          'telefone',
          'numOrcamento',
          'instituicao',
          'sigla',
          'curso',
          'cidade',
          'estado',
          'representante',
          'statusCronograma',
          'dataFormatura',
          'dataChegada',
          'dataEntrega',
        ];
      } else if (status === 'configurar' || status === 'aguardando') {
        inputs = [
          'numero',
          'gestor',
          'emailComissao',
          'telefone',
          'numOrcamento',
          'instituicao',
          'sigla',
          'curso',
          'cidade',
          'estado',
          'representante',
          'dataFormatura',
          'dataChegada',
          'dataEntrega',
          'statusCronograma',
        ];
      }
      inputs.forEach((input) => {
        if (
          this.state.contrato[input] === 'Não definido' ||
          this.state.contrato[input] === 'Invalid Date' ||
          !this.state.contrato[input]
        ) {
          classInputs[input] = 'has-error';
          existemCamposNaoPreenchidos = true;
        }
        if (
          input === 'curso' &&
          this.state.showModalNovo === 'ate' &&
          this.state.contrato[input] === 'VARIOS CURSOS' &&
          this.state.cursosSelecionados.length === 0 &&
          this.state.contrato.turmas === 0
        ) {
          classInputs['cursosSelecionados'] = {
            color: '#dd4b39',
            fontWeight: 'bolder',
          };
          existemCamposNaoPreenchidos = true;
        }
      });
      this.setState({ classInputs });
      if (existemCamposNaoPreenchidos) {
        return true;
      }
      return false;
    }
    classInputs['gestor'] = 'has-error';
    this.setState({ classInputs });
    return true;
  }

  verificarSeOContratoExiste() {
    if (
      this.state.oldContrato.numero !== undefined &&
      this.state.oldContrato.numero > 0
    ) {
      this.props
        .obterContratoPeloNumero(this.state.oldContrato.numero)
        .then(() => {
          this.setState({ output: 'none' }, () => {
            if (this.props.contratoOld === undefined) {
              this.setState({ habilitarInputsOldForm: true });
            } else {
              this.setState({
                output: '',
                habilitarInputsOldForm: false,
                oldContrato: {
                  emailComissao: '',
                  emailDesigner: '',
                  prazoFinalizacao: '',
                  dono: '',
                },
              });
            }
          });
        })
        .catch((err) => {
          toast.error(
            'Não foi possível validar a existência do contrato. Tente novamente!'
          );
        });
    }
  }

  handleKitObs(kit) {
    let contrato = this.state.contrato;
    if (contrato.itens !== undefined && contrato.itens.length > 0) {
      contrato.itens.forEach((item) => {
        if (item.id === kit.id) {
          if (item.tipo === 'Sim') {
            item.tipo = 'Não';
          } else {
            item.tipo = 'Sim';
          }
        }
      });
    }
    this.setState({ contrato });
  }

  handleChangeCursos(cursosSelecionados) {
    this.setState({
      cursosSelecionados: cursosSelecionados === null ? [] : cursosSelecionados,
    });
  }

  _renderFormContrato() {
    return (
      <div>
        <form onChange={this.alterarForm}>
          <div className='row'>
            <div
              className={`form-group col-xs-12 col-md-4 ${this.state.classInputs.numero}`}
            >
              <label htmlFor='numero'>Contrato:</label>
              <input
                type='text'
                value={this.state.contrato.numero}
                className='form-control'
                name='numero'
                disabled
                required
              />
            </div>
            <div
              className={`form-group col-xs-12 col-sm-4 ${this.state.classInputs.numOrcamento}`}
            >
              <label htmlFor='gestor'>Proposta:</label>
              <input
                type='text'
                className='form-control'
                disabled
                name='numOrcamento'
                value={this.state.contrato.numOrcamento}
                required
              />
            </div>
            <div
              className={`form-group col-xs-12 col-md-4 ${this.state.classInputs.gestor}`}
            >
              <label htmlFor='gestor'>Designer:</label>
              {this.state.showModalNovo === 'orc' ? (
                <Select
                  name='gestor'
                  value={this.state.designerSelecionado}
                  onChange={this.handleChangeGestor.bind(this)}
                  options={this.state.designers}
                  required
                />
              ) : (
                <input
                  type='text'
                  className='form-control'
                  disabled
                  name='gestor'
                  value={this.state.contrato.gestor}
                />
              )}
            </div>
          </div>
          <div className='row'>
            <div
              className={`form-group col-xs-12 col-md-8 ${this.state.classInputs.emailComissao}`}
            >
              <label htmlFor='email'>E-mail principal:</label>
              <input
                type='email'
                value={this.state.contrato.emailComissao}
                className='form-control'
                name='emailComissao'
                disabled={this.state.showModalNovo === 'des'}
                required
              />
            </div>
            <div
              className={`form-group col-xs-12 col-md-4 ${this.state.classInputs.telefone}`}
            >
              <label htmlFor='telefone'>Telefone principal:</label>
              <input
                type='text'
                value={this.state.contrato.telefone}
                className='form-control'
                name='telefone'
                disabled={this.state.showModalNovo === 'des'}
                required
              />
            </div>
          </div>
          <div className='row'>
            {this.state.contrato.contatos &&
            this.state.contrato.contatos.length > 0 ? (
              <div className='col-xs-12'>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <label>Contatos:</label>
                  <a
                    onClick={() =>
                      this.setState({
                        modalCorrecao: {
                          show: true,
                          titulo: 'Adição de contato',
                          tipo: 'adicao',
                          dadosAlteracao: { nome: '', email: '', telefone: '' },
                        },
                      })
                    }
                  >
                    <i
                      style={{ color: '#1890ff', cursor: 'pointer' }}
                      className='fa fa-plus'
                    />{' '}
                    Solicitar adição de contato
                  </a>
                </div>
                <div className='table-responsive'>
                  <table className='table table-bordered table-striped'>
                    <thead>
                      <tr>
                        <th>Nome</th>
                        <th>E-mail</th>
                        <th>Data de Nascimento</th>
                        <th>Telefone 1</th>
                        <th>Telefone 2</th>
                        <th>Principal</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.contrato.contatos.map((contato, i) => (
                        <tr key={i}>
                          <td>{contato.Nome}</td>
                          <td>{contato.email}</td>
                          <td>{contato.dataNascimento ? contato.dataNascimento : ""}</td>
                          <td>{contato.Celular}</td>
                          <td>{contato.outroTelefone}</td>
                          <td>
                            {contato.ContatoPrinc === 'SIM' ? 'SIM' : 'NÃO'}
                          </td>
                          <td>
                            <a
                              onClick={() =>
                                this.setState({
                                  modalCorrecao: {
                                    show: true,
                                    titulo: 'Alteração de contato',
                                    tipo: 'alteracao',
                                    dadosAlteracao: {
                                      nome: contato.Nome,
                                      email: contato.email,
                                      telefone: contato.Celular,
                                    },
                                  },
                                })
                              }
                            >
                              <i
                                style={{ color: '#1890ff', cursor: 'pointer' }}
                                className='fa fa-exclamation-triangle'
                              />{' '}
                              Solicitar correção
                            </a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div className='col-xs-12'>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <label>Contatos:</label>
                </div>
                <p>Contrato não encontrado no METRICS!</p>
              </div>
            )}
          </div>
          <div className='row'>
            <div className={`form-group col-xs-12`}>
              <label>Itens contratados:</label>
              <div className='table-responsive'>
                <table className='table table-bordered table-striped'>
                  <thead>
                    <tr>
                      <th>Item</th>
                      <th>Quantidade</th>
                      {this.state.showModalNovo !== 'des' ? (
                        <th>Preço</th>
                      ) : null}
                      <th>Tipo</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.contrato.itens.length > 0
                      ? this.state.contrato.itens.map((kit, i) => (
                          <tr key={'t' + kit.id + i}>
                            <td
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                              }}
                            >
                              {kit.produto}{' '}
                              {kit.itens === undefined ? null : (
                                <i
                                  title='Clique para ver mais informações'
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => {
                                    this.setState({
                                      showModalItensKit: true,
                                      kitSelecionado: kit,
                                      qtdKitSelecionado: kit.quantidade,
                                    });
                                  }}
                                  className='fa fa-info'
                                ></i>
                              )}
                            </td>
                            <td>{kit.quantidade}</td>
                            {this.state.showModalNovo !== 'des' ? (
                              <td>
                                {'R$ ' +
                                  (kit.preco === null ? 0 : kit.preco)
                                    .toFixed(2)
                                    .toLocaleString('pt-BR')}
                              </td>
                            ) : null}
                            <td>{kit.observacao}</td>
                          </tr>
                        ))
                      : null}
                    {this.state.showModalNovo !== 'des' ? (
                      <tr>
                        <td colSpan={3} style={{ textAlign: 'right' }}>
                          <strong>PREÇO TOTAL</strong>
                        </td>
                        <td>
                          {'R$ ' +
                            (this.state.precoTotalOrcamento === '0,00' ||
                            this.state.precoTotalOrcamento === ''
                              ? '0,00'
                              : this.state.precoTotalOrcamento)}
                        </td>
                      </tr>
                    ) : null}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className='row'>
            <div
              className={`form-group col-xs-12 col-md-4 ${this.state.classInputs.statusCronograma}`}
            >
              <label htmlFor='statusCronograma'>Status:</label>
              <select
                className='form-control'
                value={this.state.contrato.statusCronograma}
                name='statusCronograma'
                onChange={(e) => {
                  this.setState({
                    contrato: {
                      ...this.state.contrato,
                      statusCronograma: e.target.value,
                    },
                  });
                }}
                disabled={this.state.showModalNovo === 'des'}
                required
              >
                <option value=''>Selecione</option>
                <option value='Ativo'>Ativo</option>
                <option value='Inativo'>Inativo</option>
                <option value='Stand by'>Stand by</option>
              </select>
            </div>
            <div className={'form-group checkbox col-xs-12 col-md-4'}>
              <label>
                <input
                  type='checkbox'
                  checked={this.state.contrato.contratoVitrine}
                  disabled={this.state.showModalNovo === 'des'}
                  onChange={(e) => {
                    this.setState({ contrato_vitrine: e.target.checked });
                  }}
                  name='contratoVitrine'
                />
                Contrato vitrine
              </label>
            </div>
          </div>
          <div className='row'>
            <div
              className={`form-group col-xs-12 col-md-8 ${this.state.classInputs.instituicao}`}
            >
              <label htmlFor='instituicao'>Instituição:</label>
              <input
                type='text'
                readOnly
                value={this.state.contrato.instituicao}
                className='form-control'
                name='instituicao'
                required
              />
            </div>
            <div
              className={`form-group col-xs-12 col-md-4 ${this.state.classInputs.sigla}`}
            >
              <label htmlFor='sigla'>Sigla:</label>
              <input
                type='text'
                readOnly
                value={this.state.contrato.sigla}
                className='form-control'
                name='sigla'
                required
              />
            </div>
          </div>
          <div className='row'>
            <div
              className={`form-group col-xs-12 ${this.state.classInputs.curso}`}
            >
              <label htmlFor='curso'>Curso:</label>
              {this.state.contrato.status === 'cadastrar' &&
              this.state.contrato.curso === 'VARIOS CURSOS' ? (
                this.state.contrato.turmas &&
                this.state.contrato.turmas.length === 0 ? (
                  this.state.cursos.length > 0 ? (
                    <div>
                      <Select
                        placeholder='Selecione todos os cursos que compõem este contrato'
                        name='curso'
                        value={this.state.cursosSelecionados}
                        onChange={this.handleChangeCursos.bind(this)}
                        options={this.state.cursos}
                        isMulti
                        components={animatedComponents}
                        className='basic-multi-select'
                        classNamePrefix='select'
                        closeMenuOnSelect={false}
                        required
                      />
                      <p style={this.state.classInputs.cursosSelecionados}>
                        Selecione ao menos um curso
                      </p>
                    </div>
                  ) : (
                    <p>
                      Erro ao carregar a lista de cursos. Atualize a tela e
                      tente novamente!
                    </p>
                  )
                ) : (
                  <div
                    style={{
                      width: '100%',
                      overflowX: 'auto',
                      display: 'flex',
                      backgroundColor: '#eee',
                      border: '1px solid #d2d6de',
                      padding: '6px 12px 6px 10px',
                    }}
                  >
                    {this.state.contrato.turmas.map((turma, i) => (
                      <div
                        key={i}
                        style={{
                          backgroundColor: '#ccc',
                          marginRight: 5,
                          padding: '0px 10px',
                          borderRadius: 15,
                        }}
                      >
                        {turma.curso}
                      </div>
                    ))}
                  </div>
                )
              ) : (
                <input
                  type='text'
                  readOnly
                  value={this.state.contrato.curso}
                  className='form-control'
                  name='curso'
                  required
                />
              )}
            </div>
          </div>
          <div className='row'>
            <div
              className={`form-group col-xs-8 ${this.state.classInputs.cidade}`}
            >
              <label htmlFor='cidade'>Cidade:</label>
              <input
                type='text'
                readOnly
                value={this.state.contrato.cidade}
                className='form-control'
                name='cidade'
                required
              />
            </div>
            <div
              className={`form-group col-xs-4 ${this.state.classInputs.estado}`}
            >
              <label htmlFor='estado'>Estado:</label>
              <input
                type='text'
                readOnly
                value={this.state.contrato.estado}
                className='form-control'
                name='estado'
                required
              />
            </div>
          </div>
          <div className='row'>
            <div
              className={`form-group col-sm-6 ${this.state.classInputs.representante}`}
            >
              <label htmlFor='representante'>Representante:</label>
              <input
                type='text'
                readOnly
                value={this.state.contrato.representante}
                className='form-control'
                name='representante'
                required
              />
            </div>
            <div
              className={`form-group col-sm-6 ${this.state.classInputs.parceiro}`}
            >
              <label htmlFor='parceiro'>Parceiro:</label>
              <input
                type='text'
                readOnly
                value={this.state.contrato.parceiro}
                className='form-control'
                name='parceiro'
                required
              />
            </div>
          </div>
          <div className='row'>
            <div
              className={`col-xs-12 col-sm-6 col-md-3 ${this.state.classInputs.dataFormatura}`}
            >
              <label htmlFor='dataFormatura'>Data da Formatura:</label>
              <input
                type='date'
                value={this.state.contrato.dataFormatura}
                className='form-control'
                name='dataFormatura'
                disabled={this.state.showModalNovo === 'des'}
                required
              />
            </div>
            <div
              className={`col-xs-12 col-sm-6 col-md-3 ${this.state.classInputs.dataEntrega}`}
            >
              <label htmlFor='dataEntrega'>Data da Entrega:</label>
              <input
                type='date'
                value={this.state.contrato.dataEntrega}
                className='form-control'
                name='dataEntrega'
                disabled={this.state.showModalNovo !== 'orc'}
                required
              />
            </div>
            <div
              className={`col-xs-12 col-sm-6 col-md-3 ${this.state.classInputs.dataChegada}`}
            >
              <label htmlFor='dataChegada'>Data da Chegada:</label>
              <input
                type='date'
                value={this.state.contrato.dataChegada}
                className='form-control'
                name='dataChegada'
                disabled={this.state.showModalNovo !== 'orc'}
                required
              />
            </div>
            <div
              className={`col-xs-12 col-sm-6 col-md-3 ${this.state.classInputs.prazoFinalizacao}`}
            >
              <label htmlFor='prazoFinalizacao'>Prazo de Finalização:</label>
              <input
                type='date'
                value={this.state.contrato.prazoFinalizacao}
                className='form-control'
                name='prazoFinalizacao'
                disabled
                readOnly
                required
              />
            </div>
          </div>
          <div className='row'>
            {this.state.showModalNovo === 'orc' ? (
              <input
                style={{ marginTop: 50, marginRight: 15 }}
                type='button'
                onClick={this.cadastrarContrato.bind(this)}
                className='btn btn-success flat pull-right btn-lg'
                value='Cadastrar contrato'
              />
            ) : this.state.showModalNovo === 'ate' ? (
              <div>
                {this.state.showModalNovo === 'ate' &&
                this.props.usuario.autenticado.tipo !== 'orc' ? (
                  <input
                    style={{ marginTop: 50, marginRight: 15 }}
                    type='button'
                    onClick={this.configurarContrato.bind(this, 'liberar')}
                    className='btn btn-danger flat pull-right btn-lg'
                    value='Liberar contrato'
                  />
                ) : null}
                <input
                  style={{ marginTop: 50, marginRight: 15 }}
                  type='button'
                  onClick={this.configurarContrato.bind(this, 'salvar')}
                  className='btn btn-success flat pull-right btn-lg'
                  value='Salvar alterações'
                />
              </div>
            ) : null}
          </div>
        </form>
      </div>
    );
  }

  _renderTableInserir() {
    return (
      <div className='table-responsive'>
        <table
          id='datatableMetricsInserir'
          className='table table-condensed table-bodered table-hover'
        >
          <thead>
            <tr>
              <th>Contrato</th>
              <th>Contratante</th>
              <th>Telefone</th>
              <th>Data de Formatura</th>
            </tr>
          </thead>
          <tbody>
            {this.props.contratosInserir.map((c, i) => (
              <tr
                key={i}
                onClick={this.setarInformacoesModalContrato.bind(
                  this,
                  c,
                  'orc'
                )}
              >
                <td>{c.numero !== undefined ? c.numero : ''}</td>
                <td>{c.contratante !== undefined ? c.contratante : c.Nome}</td>
                <td>{c.telefone !== undefined ? c.telefone : c.Telefone}</td>
                <td>
                  {c.dataFormatura !== undefined
                    ? new Date(c.dataFormatura).toLocaleDateString('pt-BR', {
                        timeZone: 'UTC',
                      })
                    : ''}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  _renderTableCadastrar() {
    return (
      <div className='table-responsive'>
        <table
          id='datatableMetricsCadastrar'
          className='table table-condensed table-bodered table-hover'
        >
          <thead>
            <tr>
              <th>Contrato</th>
              <th>Contratante</th>
              <th>Telefone</th>
              <th>Cidade</th>
              <th>Estado</th>
              <th>Instituição</th>
              <th>Sigla</th>
              <th>Curso</th>
              <th>Data de Formatura</th>
            </tr>
          </thead>
          <tbody>
            {this.state.contratosNovos.map((c, i) => (
              <tr key={i} onClick={this.abrirModalContrato.bind(this, c)}>
                <td>{c.numero}</td>
                <td>{c.contratante}</td>
                <td>{c.telefone}</td>
                <td>{c.cidade}</td>
                <td>{c.estado}</td>
                <td>{c.instituicao}</td>
                <td>{c.sigla}</td>
                <td>{c.curso}</td>
                <td>
                  {c.dataFormatura !== null
                    ? new Date(c.dataFormatura).toLocaleDateString('pt-BR', {
                        timeZone: 'UTC',
                      })
                    : ''}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.state.iniciar ? (
          <div className='col-md-12' hidden={!this.state.iniciar}>
            <div className='alert alert-primary ng-hide'>
              <h4 style={{ textAlign: 'center' }}>
                <i className='fa fa-spinner fa-pulse fa-fw' /> Carregando
              </h4>
            </div>
          </div>
        ) : (
          <section>
            {this.props.usuario.autenticado.tipo === 'orc' ? (
              <div className='box'>
                <div className='box-body' style={{ padding: 10 }}>
                  <h3 style={{ color: 'rgba(0, 0, 0, 0.85)' }}>
                    Cadastro de Contrato
                  </h3>
                  {this._renderTableInserir()}
                </div>
              </div>
            ) : null}
            <div className='box'>
              <div className='box-body' style={{ padding: 10 }}>
                <h3 style={{ color: 'rgba(0, 0, 0, 0.85)' }}>
                  {this.props.usuario.autenticado.tipo === 'comum'
                    ? 'Aguardando configuração do cronograma'
                    : 'Aguardando confirmação contratual'}
                </h3>
                {this._renderTableCadastrar()}
                <br />
                <button
                  className='btn btn-danger'
                  onClick={() => {
                    this.setState({
                      showModalContratoAntigo: true,
                      output: 'none',
                      habilitarInputsOldForm: false,
                      oldContrato: {
                        emailComissao: '',
                        emailDesigner: '',
                        prazoFinalizacao: '',
                        dono: '',
                      },
                    });
                  }}
                >
                  <i className='fa fa-plus'></i> Cadastrar contrato antigo
                </button>
              </div>
            </div>
            <Modal
              show={this.state.showModalNovo !== false}
              onHide={() => {
                this.setState({ showModalNovo: false });
              }}
              backdrop='static'
              dialogClassName='modal-90w'
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  Informações do contrato{' '}
                  <span style={{ textDecoration: 'underline' }}>
                    {this.state.contrato.numero}
                  </span>{' '}
                  |
                  {this.state.contrato.pagamentoIndividual === 'true' ? (
                    <span
                      style={{ marginLeft: 5, padding: '4px 10px' }}
                      className='badge alert-info'
                    >
                      Pagamento individual
                    </span>
                  ) : null}
                  {this.state.contrato.conviteOnline ? (
                    <span
                      style={{ marginLeft: 5, padding: '4px 10px' }}
                      className='badge alert-info'
                    >
                      Convite on-line
                    </span>
                  ) : null}
                  {this.state.contrato.sistemaPagto ? (
                    <span
                      style={{ marginLeft: 5, padding: '4px 10px' }}
                      className='badge alert-info'
                    >
                      Pagto. pelo sistema
                    </span>
                  ) : null}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {this.state.abrindoContrato ? (
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <i className='fa fa-spinner fa-spin fa-2x'></i>
                  </div>
                ) : (
                  this._renderFormContrato()
                )}
              </Modal.Body>
              <Modal.Footer></Modal.Footer>
            </Modal>
            <Modal
              show={this.state.showModalItensKit}
              onHide={() => {
                this.setState({ showModalItensKit: false });
              }}
              dialogClassName='modal-50w'
            >
              <Modal.Header closeButton>
                <Modal.Title>Outras informações</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {this.state.kitSelecionado !== null &&
                this.state.kitSelecionado.itens !== null ? (
                  <div>
                    <h4>Composição</h4>
                    <ul style={{ marginBottom: 30 }}>
                      {this.state.kitSelecionado.itens
                        .split(';')
                        .map((item, i) =>
                          item !== '' ? <li key={i}>{item}</li> : null
                        )}
                    </ul>
                  </div>
                ) : null}
                {this.state.kitSelecionado !== null ? (
                  <div>
                    <h4>Composição detalhada</h4>
                    <ul>
                      {this.state.kitSelecionado.descricao
                        .split(' / ')
                        .map((descricao, i) =>
                          descricao !== ''
                            ? descricao
                                .split(',')
                                .map((desc, j) => (
                                  <li key={'desc' + i + j}>{desc}</li>
                                ))
                            : null
                        )}
                    </ul>
                  </div>
                ) : null}
              </Modal.Body>
              <Modal.Footer></Modal.Footer>
            </Modal>
            <Modal
              show={this.state.showModalContratoAntigo !== false}
              onHide={() => {
                this.setState({ showModalContratoAntigo: false });
              }}
              dialogClassName='modal-50w'
            >
              <Modal.Header closeButton>
                <Modal.Title>Cadastro de contratos antigos</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className='alert alert-danger'>
                  <strong>ATENÇÃO:</strong> <br /> <br />
                  1 - Essa função é destinada somente ao cadastro de CONTRATOS
                  ANTIGOS! <br />
                  2 - Todos os contratos novos são cadastrados automaticamente,
                  e são liberados pelas atendentes.
                  <br />
                  3 - Certifique-se de que o cronograma já esteja gerado ao
                  cadastrar o contrato! <br />
                  <br />
                  <small>* Todos os campos são obrigatórios!</small>
                </div>
                <form onSubmit={this.cadastrarContratoAntigo.bind(this)}>
                  <div className='row'>
                    <div
                      className={`form-group col-sm-12 col-md-5 ${this.state.classInputs.numero}`}
                    >
                      <div className='input-group'>
                        <label htmlFor='oldNumero'>Número do contrato</label>
                        <div className='input-group'>
                          <input
                            type='number'
                            value={this.state.oldContrato.numero}
                            onChange={this.alterarFormAntigo.bind(this)}
                            className='form-control'
                            id='oldNumero'
                            name='numero'
                            required
                          />
                          <span className='input-group-addon'>
                            <button
                              type='button'
                              className='btn btn-default'
                              onClick={this.verificarSeOContratoExiste.bind(
                                this
                              )}
                            >
                              <i className='fa fa-search'></i>
                            </button>
                          </span>
                        </div>
                      </div>
                      <output
                        className={`form-group ${this.state.output}`}
                        style={{ color: '#DD4B39' }}
                      >
                        <small>
                          <strong>Este contrato já está cadastrado</strong>
                        </small>
                      </output>
                    </div>
                    <div
                      className={`form-group col-xs-12 col-md-7 ${this.state.classInputs.prazoFinalizacao}`}
                    >
                      <label htmlFor='oldPrazoFinalizacao'>
                        Prazo de finalização
                      </label>
                      <input
                        type='date'
                        disabled={!this.state.habilitarInputsOldForm}
                        value={this.state.oldContrato.prazoFinalizacao}
                        onChange={this.alterarFormAntigo.bind(this)}
                        className='form-control'
                        id='oldPrazoFinalizacao'
                        required
                        name='prazoFinalizacao'
                      />
                    </div>
                  </div>
                  <div className='row'>
                    <div
                      className={`form-group col-md-12 ${this.state.classInputs.emailComissao}`}
                    >
                      <label htmlFor='oldEmailComissao'>
                        E-mail da comissão
                      </label>
                      <input
                        type='email'
                        disabled={!this.state.habilitarInputsOldForm}
                        value={this.state.oldContrato.emailComissao}
                        onChange={this.alterarFormAntigo.bind(this)}
                        className='form-control'
                        id='oldEmailComissao'
                        name='emailComissao'
                        required
                      />
                    </div>
                  </div>
                  <div className='row'>
                    <div
                      className={`form-group col-md-12 ${this.state.classInputs.emailDesigner}`}
                    >
                      <label htmlFor='oldEmailDesigner'>
                        E-mail do(a) gestor(a)
                      </label>
                      <input
                        type='email'
                        disabled={!this.state.habilitarInputsOldForm}
                        value={this.state.oldContrato.emailDesigner}
                        onChange={this.alterarFormAntigo.bind(this)}
                        className='form-control'
                        id='oldEmailDesigner'
                        name='emailDesigner'
                        required
                      />
                    </div>
                  </div>
                  <Modal.Footer>
                    <button type='submit' className='btn btn-success btn-lg'>
                      Cadastrar
                    </button>
                  </Modal.Footer>
                </form>
              </Modal.Body>
            </Modal>
            <Modal
              show={this.state.modalCorrecao.show}
              onHide={() => {
                this.setState({
                  modalCorrecao: { ...this.state.modalCorrecao, show: false },
                });
              }}
              backdrop='static'
              dialogClassName='modal-50w'
            >
              <Modal.Header closeButton>
                <Modal.Title>{this.state.modalCorrecao.titulo}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <form onSubmit={this.enviarEmail}>
                  <div className='form-group'>
                    <label htmlFor='modalCorrecaoNome'>Nome</label>
                    <input
                      type='text'
                      name='nome'
                      id='modalCorrecaoNome'
                      className='form-control'
                      value={this.state.modalCorrecao.dadosAlteracao.nome}
                      disabled={this.state.modalCorrecao.tipo === 'alteracao'}
                      onChange={
                        this.state.modalCorrecao.tipo === 'alteracao'
                          ? null
                          : (e) =>
                              this.setState({
                                modalCorrecao: {
                                  ...this.state.modalCorrecao,
                                  dadosAlteracao: {
                                    ...this.state.modalCorrecao.dadosAlteracao,
                                    nome: e.target.value,
                                  },
                                },
                              })
                      }
                    />
                  </div>
                  <div className='row'>
                    <div className='form-group col-sm-12 col-md-6'>
                      <label htmlFor='modalCorrecaoEmail'>E-mail</label>
                      <input
                        type='email'
                        name='email'
                        id='modalCorrecaoEmail'
                        className='form-control'
                        value={this.state.modalCorrecao.dadosAlteracao.email}
                        disabled={this.state.modalCorrecao.tipo === 'alteracao'}
                        onChange={
                          this.state.modalCorrecao.tipo === 'alteracao'
                            ? null
                            : (e) =>
                                this.setState({
                                  modalCorrecao: {
                                    ...this.state.modalCorrecao,
                                    dadosAlteracao: {
                                      ...this.state.modalCorrecao
                                        .dadosAlteracao,
                                      email: e.target.value,
                                    },
                                  },
                                })
                        }
                      />
                    </div>
                    <div className='form-group col-sm-12 col-md-6'>
                      <label htmlFor='modalCorrecaoTelefone'>Telefone 1</label>
                      <input
                        type='text'
                        name='telefone'
                        id='modalCorrecaoTelefone'
                        className='form-control'
                        value={this.state.modalCorrecao.dadosAlteracao.telefone}
                        disabled={this.state.modalCorrecao.tipo === 'alteracao'}
                        onChange={
                          this.state.modalCorrecao.tipo === 'alteracao'
                            ? null
                            : (e) =>
                                this.setState({
                                  modalCorrecao: {
                                    ...this.state.modalCorrecao,
                                    dadosAlteracao: {
                                      ...this.state.modalCorrecao
                                        .dadosAlteracao,
                                      telefone: e.target.value,
                                    },
                                  },
                                })
                        }
                      />
                    </div>
                    <div className='form-group col-sm-12 col-md-6'>
                      <label htmlFor='modalCorrecaoOutroTelefone'>
                        Telefone 2
                      </label>
                      <input
                        type='text'
                        name='telefone'
                        id='modalCorrecaoOutroTelefone'
                        className='form-control'
                        value={
                          this.state.modalCorrecao.dadosAlteracao.outroTelefone
                        }
                        disabled={this.state.modalCorrecao.tipo === 'alteracao'}
                        onChange={
                          this.state.modalCorrecao.tipo === 'alteracao'
                            ? null
                            : (e) =>
                                this.setState({
                                  modalCorrecao: {
                                    ...this.state.modalCorrecao,
                                    dadosAlteracao: {
                                      ...this.state.modalCorrecao
                                        .dadosAlteracao,
                                      outroTelefone: e.target.value,
                                    },
                                  },
                                })
                        }
                      />
                    </div>
                  </div>
                  {this.state.modalCorrecao.tipo === 'alteracao' ? (
                    <div className='form-group'>
                      <label htmlFor='inputCorrecao'>
                        Digite abaixo as alterações necessárias
                      </label>
                      <textarea
                        id='inputCorrecao'
                        className='form-control'
                        rows={6}
                        placeholder={`Exemplo:\n\nAlterar nome para João Ninguém\nAlterar e-mail para joao@ninguem.com\nAlterar telefone para (43) 9 9191 9292`}
                        onChange={(e) =>
                          this.setState({
                            modalCorrecao: {
                              ...this.state.modalCorrecao,
                              inputCorrecao: e.target.value,
                            },
                          })
                        }
                      ></textarea>
                    </div>
                  ) : null}
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      marginTop: 15,
                    }}
                  >
                    <button
                      type='submit'
                      className='btn btn-success btn-flat'
                      disabled={this.state.modalCorrecao.carregando}
                    >
                      {this.state.modalCorrecao.carregando ? (
                        <span>
                          <i className='fa fa-spinner fa-pulse' /> Aguarde
                        </span>
                      ) : (
                        'Salvar'
                      )}
                    </button>
                  </div>
                </form>
              </Modal.Body>
              <Modal.Footer></Modal.Footer>
            </Modal>
            <Modal
              show={this.state.modalCorrecao.emailEnviado}
              onHide={() => {
                this.setState({
                  modalCorrecao: {
                    ...this.state.modalCorrecao,
                    emailEnviado: false,
                  },
                });
              }}
              dialogClassName='modal-50w'
            >
              <Modal.Body>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                  }}
                >
                  <img src='/images/success.png' alt='Sucesso' height='75' />
                  <h2 style={{ textAlign: 'center' }}>
                    Solicitação registrada com sucesso!
                  </h2>
                  <button
                    className='btn btn-lg'
                    style={{ marginTop: 5 }}
                    onClick={() => {
                      this.setState({
                        modalCorrecao: {
                          ...this.state.modalCorrecao,
                          emailEnviado: false,
                        },
                      });
                    }}
                  >
                    Continuar
                  </button>
                </div>
              </Modal.Body>
            </Modal>
          </section>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    itensCadastrados: state.item.todos,
    usuario: {
      autenticado: state.usuario.autenticado,
      todos: state.usuario.todos,
    },
    contrato: state.contrato.ultimo,
    contratoOld: state.contrato.especifico,
    contratosInserir: state.contrato.inserir,
    contratosNovos: state.contrato.cadastrados,
    contratosConfigurar: state.contrato.configurar,
    usuarioContrato: state.usuarioContrato.todos,
  };
};

export default connect(mapStateToProps, {
  cadastrarAcao,
  adicionarTurma,
  adicionarContrato,
  adicionarContratoAntigo,
  obterContratosInserir,
  obterContratosCadastrados,
  obterContratosConfigurar,
  obterContratoPeloNumero,
  editarContrato,
  editarUsuario,
  obterItensPeloContrato,
  obterUsuariosPeloContrato,
  obterUsuariosAdministracao,
  transferirContrato,
})(ContratosGerenciamento);



// WEBPACK FOOTER //
// ./src/views/ContratosGerenciamento/index.js